export const EMPTY_ALERT = {
  show: false,
  text: '',
  subText: '',
  timeout: 0,
  type: 'info' as 'info' | 'success' | 'error' | 'warning',
};

export const PROVIDER_ROLE_CODE = 'PROVIDER';
export const EMPLOYER_ROLE_CODE = 'EMPLOYER';
